module.exports = __webpack_public_path__ + "img/ercode.05b5b346.png";